/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Problem_2_DescInputs */

const en_mk_problem_2_desc = /** @type {(inputs: Mk_Problem_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One tool to write, one to summarize, another for tasks — results get copy-pasted by hand, none of it woven into how the team actually works.`)
};

const id_mk_problem_2_desc = /** @type {(inputs: Mk_Problem_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu alat untuk menulis, satu untuk merekap, satu lagi untuk tugas — hasilnya disalin-tempel manual, tidak ada yang menyatu dengan alur kerja tim.`)
};

/**
* | output |
* | --- |
* | "One tool to write, one to summarize, another for tasks — results get copy-pasted by hand, none of it woven into how the team actually works." |
*
* @param {Mk_Problem_2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_problem_2_desc = /** @type {((inputs?: Mk_Problem_2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Problem_2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_problem_2_desc(inputs)
	return en_mk_problem_2_desc(inputs)
});